export default "__VITE_ASSET__C_OU0VaI__"